export const PHONE_NUMBER = '(063) 485 89 33';
export const PHONE_HREF = 'tel:+380634858933';
